/**
 * グループ会社ページ用のスクリプト
 */
if (is_route('end_holding.index')) {
    // コンテンツ読み込み後
    $(document).on('bss:onload', function() {
        end_holding_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.end_holding_event_set = function() {

    /*---- 設定の表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        // 設定モーダルを表示
        _modal.create(this, 'setting-modal', ['id']);
    });

    /*---- 設定の保存時 ----*/

    // 設定実行時
    $(document).on('click', '[data-save-modal]', function () {
        _modal.submit(this, 'save-modal', function(results) {
        });
    });

    /*---- 削除確認の表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-confirm-modal]', function () {
        // 設定モーダルを表示
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal', function(results) {
            // ツールバーの更新が必要なのでリロードする
            location.reload();
        },null,'-form',true);
    });

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#csv-dl-list').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });



    $(document).on('click', '.btn_download_blank_application', function (e) {
        e.preventDefault();
        const action = $(this).data('action');   // data-action 属性にURLが入っている
        const is_rj = $(this).data('is_rj');
        const is_bss = $(this).data('is_bss');
        const is_dejidora = $(this).data('is_dejidora');
        _ajax.blob(action, {is_rj,is_bss,is_dejidora}, function (result) {
            // Blob をダウンロードリンクとして生成
            const link = document.createElement("a");
            link.href = URL.createObjectURL(result);
            let file_name = '利用申込書';
            if(is_bss) {
                if(!is_dejidora) {
                    file_name = is_rj ? '【RJ様】BusinessSupportSystem利用申込書.xlsx' : '【一般】BusinessSupportSystem利用申込書.xlsx'
                }
                else
                {
                    file_name = is_rj ? '【RJ様】BusinessSupportSystem利用申込書(車載器).xlsx' : '【一般】BusinessSupportSystem利用申込書(車載器).xlsx'
                }
            }else
            {
                file_name = is_rj ? '【RJ様】BSSforALC利用申込書.xlsx' : '【一般】BSSforALC利用申込書.xlsx'
            }
            link.setAttribute("download", file_name); // 固定ファイル名
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        }, function (xhr, status, errorThrown) {
            _error.omitted(xhr, status, errorThrown);
        });
        return false;
    });

    $(document).on('click', '[data-select-section-modal]', function () {
        // 営業所選択モーダルを表示
        _modal.create(this, 'select-section-modal', ['id','is_dejidora']);
    });

// ========== 営業所 選択数カウンタ & 全選択制御（動的モーダル対応） ==========

// ヘルパ：フォーム取得
function _getSectionForm() {
  return $('#section-select-modal-form');
}

// カウント＆ヘッダーの状態を更新
    function _recalcSectionCounterAndHeader() {
        const $form = _getSectionForm();
        if ($form.length === 0) return;

        const $all = $form.find('input[name="end_section_ids[]"]');
        const total = $all.length;
        const selected = $all.filter(':checked').length;

        // カウンタ表示更新（フッター左のラベル）
        $form.find('#total-sections').text(total);
        $form.find('#selected-sections').text(selected);

        // 全選択チェックの三状態切替
        const $master = $form.find('#select-all-sections');
        if (selected === 0) {
            $master.prop('checked', false).prop('indeterminate', false);
        } else if (selected === total) {
            $master.prop('checked', true).prop('indeterminate', false);
        } else {
            $master.prop('checked', false).prop('indeterminate', true);
        }
    }

// 1) モーダルが開いたら初期化（動的ロード後のタイミング）
    $(document).on('shown.bs.modal', '#section-select-modal', function () {
        _recalcSectionCounterAndHeader();
    });

// 2) 個別チェックのたびに更新
    $(document).on('change', '#section-select-modal-form input[name="end_section_ids[]"]', function () {
        _recalcSectionCounterAndHeader();
    });

// 3) 全選択／全解除（ヘッダーのチェック）
    $(document).on('change', '#select-all-sections', function () {
        const checked = $(this).is(':checked');
        const $form = _getSectionForm();
        $form.find('input[name="end_section_ids[]"]').prop('checked', checked);
        _recalcSectionCounterAndHeader();
    });

    // 申込み拠点「選択」→ ダウンロード（件数チェック付き）
    $(document).on('click', '[data-section-selected-modal]', function (e) {
        e.preventDefault();

        const $btn = $(this);
        const $form = $('#section-select-modal-form');
        if ($form.length === 0) return false;

        // 収集
        const action = $btn.data('action') || $form.attr('action');
        const token = $form.find('input[name="_token"]').val();
        const id = $form.find('input[name="id"]').val();
        const isFrom = $form.find('input[name="is_from_section_view"]').val();
        const is_dejidora = $form.find('input[name="is_dejidora"]').val();
        const is_rj = $form.find('input[name="is_rj"]').val();
        const is_bss = $form.find('input[name="is_bss"]').val();
        const end_holding_name = $form.find('input[name="end_holding_name"]').val();

        const sectionIds = $form.find('input[name="end_section_ids[]"]:checked')
            .map(function () {
                return $(this).val();
            })
            .get();

        // ===== 件数チェック =====
        if (sectionIds.length === 0) {
            alert('営業所を選択してください。');
            return false;
        }
        if (sectionIds.length > 10) {
            alert('選択できる営業所は最大10件です。');
            return false;
        }

        // 送信ペイロード（後端が end_section_ids[] を期待するならキー名を変えてください）
        const payload = {
            _token: token,
            id: id,
            is_from_section_view: isFrom,
            is_dejidora: is_dejidora,
            is_rj: is_rj,
            end_section_ids: sectionIds
        };

        // 二重押下ガード
        $btn.prop('disabled', true);

        _ajax.blob(action, payload, function (blob) {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);

            const now = new Date();
            const pad = (n) => n.toString().padStart(2, '0');
            const timestamp = [
                now.getFullYear(),
                pad(now.getMonth() + 1),
                pad(now.getDate()),
                pad(now.getHours()),
                pad(now.getMinutes())
            ].join('');

            let fileName = '';
            if(is_bss) {
                if(!is_dejidora) {
                    fileName = is_rj ? `【RJ様】BusinessSupportSystem利用申込書（${end_holding_name}）_${timestamp}.xlsx` : `【一般】BusinessSupportSystem利用申込書（${end_holding_name}）_${timestamp}.xlsx`;
                }
                else
                {
                    fileName = is_rj ? `【RJ様】BusinessSupportSystem利用申込書(車載器)（${end_holding_name}）_${timestamp}.xlsx` : `【一般】BusinessSupportSystem利用申込書(車載器)（${end_holding_name}）_${timestamp}.xlsx`;
                }
            }
            else {
                fileName = is_rj ? `【RJ様】BSSforALC利用申込書（${end_holding_name}）_${timestamp}.xlsx` : `【一般】BSSforALC利用申込書（${end_holding_name}）_${timestamp}.xlsx`;
            }
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            setTimeout(function () {
                URL.revokeObjectURL(link.href);
                link.remove();
            }, 0);

            $('#section-select-modal').modal('hide');
            $btn.prop('disabled', false);
        }, function (xhr, status, errorThrown) {
            $btn.prop('disabled', false);
            _error.omitted(xhr, status, errorThrown);
        });

        return false;
    });

    // ========== 営業所モーダル：行内フィルタ（ページ級 / 動的モーダル対応） ==========
    (function () {
        // ---- ユーティリティ（このファイル内で再利用OK） ----
        function normalize(str) {
            if (!str) return '';
            const z2h = s => s.replace(/[！-～]/g, ch => String.fromCharCode(ch.charCodeAt(0) - 0xFEE0))
                .replace(/\u3000/g, ' ');
            return z2h(String(str)).toLowerCase().replace(/\s+/g, ' ').trim();
        }

        function rowSearchText(tr) {
            const cells = Array.from(tr.querySelectorAll('td')).slice(1, 7); // 2〜7列
            const text = cells.map(td => td.innerText || '').join(' ');
            return normalize(text);
        }

        // ---- モーダルごとのマウント/アンマウント ----
        function mountSectionFilter(modalEl) {
            const $modal = $(modalEl);
            const $input = $modal.find('#section-filter');
            const $clear = $modal.find('#clear-filter');
            if ($input.length === 0) return;

            // 念のため重複バインドを解除してから再構築
            unmountSectionFilter(modalEl);

            // 行キャッシュ作成（今回ロードされた内容に対して）
            const rows = $modal.find('[data-section-row]').toArray().map(tr => ({
                tr,
                text: rowSearchText(tr)
            }));
            const totalAll = rows.length;

            // フィルタ統計（filter-stats のみ更新。既存の総数/選択には触れない）
            function updateFilterStats() {
                const visible = $modal.find('[data-section-row][data-hidden="0"]').length;
                const hidden = Math.max(totalAll - visible, 0);
                $modal.find('#filter-stats').text(`表示中：${visible} / 全体：${totalAll}（非表示：${hidden}）`);
            }

            let timer = null;

            function runFilter() {
                const q = normalize($input.val());
                rows.forEach(({tr, text}) => {
                    const hit = !q || text.includes(q);
                    tr.style.display = hit ? '' : 'none';
                    tr.dataset.hidden = hit ? '0' : '1'; // 表示=0 / 非表示=1
                });
                updateFilterStats();
            }

            // 名前空間付きでバインド（閉じるときにまとめてoffできる）
            $input.on('input.sectionFilter', function () {
                clearTimeout(timer);
                timer = setTimeout(runFilter, 200);
            });
            if ($clear.length) {
                $clear.on('click.sectionFilter', function () {
                    $input.val('').trigger('input');
                });
            }

            // 状態を保持（後でoffするため）
            $modal.data('sectionFilter', {mounted: true});

            // 初期同期
            runFilter();
        }

        function unmountSectionFilter(modalEl) {
            const $modal = $(modalEl);
            const data = $modal.data('sectionFilter');
            if (!data || !data.mounted) return;
            $modal.find('#section-filter').off('.sectionFilter');
            $modal.find('#clear-filter').off('.sectionFilter');
            $modal.removeData('sectionFilter');
        }

        // ---- Bootstrapモーダルイベントにフック ----
        $(document).on('shown.bs.modal', '#section-select-modal', function () {
            // 既存のカウンタ更新（そのまま維持）
            _recalcSectionCounterAndHeader();
            // フィルタを今回のモーダル内容に対して初期化
            mountSectionFilter(this);
        });
        $(document).on('hidden.bs.modal', '#section-select-modal', function () {
            // フィルタのイベントをクリーンアップ
            unmountSectionFilter(this);
        });
    })();

}
